// src/app/audit/AI/CoPilotV2/components/NewChatModal.js
import React, { useState } from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

import {
    DEFAULT_PARAMS,
    DEFAULT_CONTEXT,
    INITIAL_FORM_STATE
  } from '../constants/chatConstants';

const generateTopicName = (prompt) => {
  return prompt?.substring(0, 50).replace(/[^\w\s]/gi, '') || 'New Chat';
};

const NewChatModal = ({ isOpen, chatUserName, chatToken, onClose, onSubmit }) => {
  const [formData, setFormData] = useState(INITIAL_FORM_STATE);

  console.log('chatUserName', chatUserName);
  const handleSubmit = (e) => {
    e.preventDefault();
    
    try {
      const messageId = uuidv4();
      const payload = {
        token: chatToken,
        name: generateTopicName(formData.promptQuery),
        initial_message: {  // Renamed for clarity
          id: messageId,
          message: formData.promptQuery,
          user: chatUserName,
          timestamp: new Date().toISOString(),
          type: 'user'  // Add message type
        },
        contextData: formData.contextData,
        params: formData.params,
        status: 'active'  // Add room status
      };

      onSubmit(payload);
      onClose();
    } catch (error) {
      console.error('Error creating chat:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>Start New Chat</ModalTitle>
          <CloseButton onClick={onClose}>&times;</CloseButton>
        </ModalHeader>

        <ModalForm onSubmit={handleSubmit}>
          <FormGroup>
            <Label>Initial Message</Label>
            <Input
              name="promptQuery"
              value={formData.promptQuery}
              onChange={handleChange}
              placeholder="Enter your message..."
              required
            />
          </FormGroup>

          <FormGroup>
            <Label>Context Data</Label>
            <TextArea
              name="contextData"
              value={formData.contextData}
              onChange={handleChange}
              placeholder="Additional context..."
              rows={4}
            />
          </FormGroup>

          <FormGroup>
            <Label>Parameters (JSON)</Label>
            <TextArea
              name="params"
              value={JSON.stringify(formData.params)}
              onChange={handleChange}
              placeholder="{}"
              rows={3}
            />
          </FormGroup>

          <ModalFooter>
            <SecondaryButton type="button" onClick={onClose}>
              Cancel
            </SecondaryButton>
            <PrimaryButton type="submit">
              Start Chat
            </PrimaryButton>
          </ModalFooter>
        </ModalForm>
      </ModalContent>
    </ModalOverlay>
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
`;

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  color: #1a1a1a;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  color: #666;
  
  &:hover {
    color: #1a1a1a;
  }
`;

const ModalForm = styled.form`
  padding: 20px;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #1a1a1a;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  min-height: ${props => props.rows * 24}px;
  
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
  }
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e9ecef;
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
`;

const PrimaryButton = styled(Button)`
  background: #007bff;
  color: white;
  border: none;
  
  &:hover {
    background: #0056b3;
  }
`;

const SecondaryButton = styled(Button)`
  background: white;
  color: #666;
  border: 1px solid #e1e1e1;
  
  &:hover {
    background: #f8f9fa;
  }
`;

export default NewChatModal;